import constant from "@/config/constant";

export function getRosterList(value) {
  return `(${
    value
      ? constant.rosterList.find((list) => list.value === value).label
      : constant.rosterList.find((list) => list.value === "full").label
  })`;
}
